











import Vue from 'vue'
import {Dictionary} from 'vuex'
import {STUD_FIELDS_VALS} from '@/constants'
export default Vue.extend({
  props: {
    filters: {
      type: Object as () => Dictionary<[string]>,
      default: () => {}
    },
    size: {
      type: String,
      default: ''
    }
  },
  methods: {
    getFilterName (filter: string): string {
      return STUD_FIELDS_VALS[filter].label || `${this.$t('labels.unknown_filter')} ${filter}`
    },
    getFilterValue (name: string, value: string): string {
      return STUD_FIELDS_VALS[name].dict && STUD_FIELDS_VALS[name].dict![value] || value || '';
    }
  }
})
